import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import Select from "react-select";
import { Link } from "react-router-dom";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import config from "config.json";

import { useForm, Controller } from "react-hook-form";
import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";

import { createEvent, getEventById } from "services/event_service";

function App() {
  const navigate = useNavigate();
  const { register, handleSubmit, setValue, control } = useForm({});

  const { eventId } = useParams();
  const [eventTimeStamp, setEventTimeStamp] = useState(new Date());
  const [teamOptions, setTeamOptions] = useState([]);

  useEffect(() => {
    async function initComponent() {
      let teams = JSON.parse(localStorage.getItem("teamIDs")).map((el) => ({
        value: el.id,
        label: el.label,
      }));

      setTeamOptions(teams);

      if (!eventId) {
        return;
      }

      let event = await getEventById(eventId);

      setValue("type", event.attributes.type);
      setValue("team", event.attributes.team.data.id);
      setValue("where", event.attributes.where);
      setValue("title", event.attributes.title);
      setEventTimeStamp(new Date(event.attributes.when));
      setValue("description", event.attributes.description);
    }

    initComponent();
  }, []);

  const submitForm = async (data) => {
    try {
      data = { ...data, when: eventTimeStamp };
      await createEvent(data);
      navigate("/calendario");
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
          <TopAdd></TopAdd>
          <div style={{ display: "flex" }}>
            <section className="section dashboard">
              <nav className="breadcrumb" aria-label="breadcrumbs">
                <ul>
                  <Link to={"/jogos"}>Jogos</Link> / Detalhe
                </ul>
              </nav>

              <div className="geral">
                <div className="hero is-footsolution">
                  <div className="columns">
                    <div className="column">
                      <h1 className="title is-3">
                        {eventId ? "Detalhe Evento" : "Adicionar Evento"}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <form onSubmit={handleSubmit((data) => submitForm(data))}>
                <div className="block">
                  <div className="field">
                    <label className="label">Equipa</label>
                    <p className="control">
                      <Controller
                        name="team"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            isDisabled={!!eventId}
                            options={teamOptions}
                            value={JSON.parse(
                              localStorage.getItem("teamIDs")
                            ).find((c) => c.id === value)}
                            onChange={(val) => onChange(val.value)}
                          />
                        )}
                      />
                    </p>
                  </div>
                </div>
                <div className="block">
                  <div className="field">
                    <label className="label">Evento</label>
                    <p className="control">
                      <select
                        className="input"
                        type="text"
                        disabled={!!eventId}
                        {...register("type", {
                          required: true,
                          minLength: 5,
                        })}
                      >
                        <option value={null}></option>
                        {config.EVENT_TYPE.map((el, idx) => (
                          <option key={idx} value={el.NAME}>
                            {el.DESCRIPTION}
                          </option>
                        ))}
                      </select>
                    </p>
                  </div>
                </div>

                <div className="block">
                  <div className="field">
                    <label className="label">Data e hora do evento</label>
                    <p className="control">
                      <DatePicker
                        scrollableYearDropdown
                        yearDropdownItemNumber={30}
                        className="input"
                        disabled={!!eventId}
                        selected={eventTimeStamp}
                        value={eventTimeStamp}
                        onChange={(value) => setEventTimeStamp(value)}
                        timeIntervals={15}
                        dateFormat="dd/MM/yyyy HH:mm"
                        timeFormat="HH:mm"
                        showTimeSelect
                      />
                    </p>
                  </div>
                </div>

                <div className="block">
                  <div className="field">
                    <label className="label">Local</label>
                    <p className="control">
                      <input
                        disabled={!!eventId}
                        className="input"
                        type="text"
                        {...register("where", {
                          required: true,
                          minLength: 5,
                        })}
                      />
                    </p>
                  </div>
                </div>

                <div className="block">
                  <div className="field">
                    <label className="label">Descrição</label>
                    <p className="control">
                      <input
                        disabled={!!eventId}
                        className="input"
                        type="text"
                        {...register("description", {
                          required: true,
                          minLength: 5,
                        })}
                      />
                    </p>
                  </div>
                </div>

                {localStorage.getItem("role") === "Treinador" ||
                  (localStorage.getItem("role") === "Clube" && (
                    <button className="button">Guardar</button>
                  ))}
              </form>
            </section>
            <RightAdd></RightAdd>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
